<div class="pt-4 pb-4 pl-md-5 pr-md-5 masthead bg-white">
    <div class="row justify-content-between align-items-center m-0">
        <p class="mb-0 h3">
            <i class="fa mr-3 fa-globe"></i>
            Countries
        </p>
        <div class="col col-md-4 pr-md-0 text-right">
            <input type="text" [(ngModel)]="searchTerm" class="form-control" placeholder="Search countries..." />
        </div>
    </div>
</div>
<div class="row mt-5" *ngIf="allCountries.length === 0">
    <div class="col-md-5 offset-md-3 col-sm-6 offset-sm-3 text-center mt-5">
        <p class="h3 mb-4">
            You have no countries configured
        </p>
        <p class="text-muted textBody--md u-marginTop--reset u-marginBottom--large">
            Please contact your system administrator.
        </p>
    </div>
</div>
<div class="container" *ngIf="allCountries.length > 0">
    <div class="row mt-5">
        <div class="col" *ngIf="isAdminOrSuperAdmin">
            <h3 class="h4 mb-4">Import data</h3>
            <button class="btn btn-primary ml-2" (click)="downloadTemplateFile()">
                Download template <i class="fa fa-file ml-2"></i>
            </button>
            <i class="fa fa-angle-right ml-2"></i>
            <importfile #import (uploadCompleteEvent)="refreshCountry()"></importfile>
        </div>
    </div>
    <div class="row mt-5" *userRoleToggle="['Admin', 'SuperAdmin', 'ContentEditor']">
        <div class="col">
            <h3 class="h4 mb-4">Export location information</h3>

            <button class="btn btn-primary ml-2" (click)="downloadCountryStatusReport()">
                Export Status Report <i class="fa fa-file ml-2"></i>
            </button>
            <button class="btn btn-primary ml-2" (click)="downloadCountryData()">
                Export Published data only<i class="fa fa-file ml-2"></i>
            </button>
            <button class="btn btn-primary ml-2" (click)="downloadCountryDraftData()">
                Export Published & Draft data <i class="fa fa-file ml-2"></i>
            </button>
        </div>
    </div>
    <div class="row mt-5">
        <div class="col">
            <h3 class="h4 mb-4">Countries</h3>
            <ul class="list-group">

                <li *ngFor="let item of allCountries | countriesfilter:searchTerm" [ngClass]="item.isDisabled == true?'list-group-item list-group-item-action justify-content-between align-items-center list-group-item-secondary':'list-group-item list-group-item-action justify-content-between align-items-center'">

                    <div *ngIf="item.isDisabled == false" routerLink="/countries/{{item.country.code}}">
                        <p class="mb-0">
                            <strong>{{item.country.name }}</strong>
                        </p>
                        <small class="text-muted mr-2" *ngIf="item.lastUpdate"><em>{{item.lastUpdate}}</em></small>
                    </div>
                    <div *ngIf="item.isDisabled == true">
                        <p class="mb-0">
                            <strong>{{item.country.name }}</strong>
                        </p>
                        <small class="text-muted mr-2" *ngIf="item.lastUpdate"><em>{{item.lastUpdate}}</em></small>
                    </div>

                    <div>

                        <ul class="nav align-items-center">
                            <li class="nav-item">
                                <workflowstagedatastatus [small]="true" [workflowStages]="item.workflowStageData"
                                                         *ngIf="item.statusId == countryDataStatus.Draft"></workflowstagedatastatus>
                            </li>
                        </ul>
                    </div>
                    <div class="btn-group">

                        <div class="align-items-end" *ngIf="item.statusId == countryDataStatus.Draft && item.workflowStageData.length == 0  &&item.isDisabled != true">
                            <h3> <span class="badge badge-light">Draft</span></h3>
                        </div>
                        <div *ngIf="item.statusId == countryDataStatus.Live &&item.isDisabled != true">
                            <h3> <span class="badge badge-info">Live</span></h3>
                        </div><div class="p-1"></div>
                        <div *ngIf="(item.statusId == countryDataStatus.Live || item.statusId == countryDataStatus.Draft) &&isAdminOrSuperAdmin==true &&item.isDisabled == false">
                            <button class="btn btn-outline-info btn-sm" (click)="disableEnableCountry('1$'+item.country.id+'$'+item.statusId)">
                                <span>Disable</span>
                            </button>
                        </div>

                        <div *ngIf="(item.statusId == countryDataStatus.Live || item.statusId == countryDataStatus.Draft) &&item.isDisabled == true && isAdminOrSuperAdmin==true">
                            <button class="btn btn-outline-info btn-sm" (click)="disableEnableCountry('0$'+item.country.id+'$'+item.statusId)">
                                <span>Enable </span>
                            </button>
                        </div>
                        <div class="p-1"></div>
                        <div *ngIf="isSuperAdmin">                            
                            <div *ngIf="(item.statusId == countryDataStatus.Live || item.statusId == countryDataStatus.Draft) &&item.isDisabled == false">
                                <button class="btn btn-outline-info btn-sm" (click)="deleteCountryContent(item.country.id+'$'+item.statusId)">
                                    <span>Delete</span>
                                </button>
                            </div>
                        </div>

                    </div>
                </li>
            </ul>
        </div>
    </div>
</div>
<downloadfile #download></downloadfile>
<confirmationcountrydialogmodal #confirmationcountrydialogmodal (onAccept)="onAccept();" (onDecline)="onDecline();"></confirmationcountrydialogmodal>
<confirmationcountrycontentdialogmodal #confirmationcountrycontentdialogmodal (onContentDeleteAccept)="onContentDeleteAccept();" (onContentDeleteDecline)="onContentDeleteDecline();"></confirmationcountrycontentdialogmodal>
